import "@babel/polyfill";
import Vue from 'vue'
import pointerlist from './modules/map.vue'
import list from './modules/stocklist/list.vue'
import favoritesList from './modules/stocklist/favorites.vue'
import imagegallery from './modules/gallery.vue'
import recentViewed from './modules/recentViewed.vue'
import slider from './modules/textlider.vue'
import photoreportList from './modules/photoreport-list.vue'
import VueLocalStorage from 'vue-ls'
// import Promise from 'promise-polyfill'
import axios from 'axios'

// Promise Polyfill
if (!window.Promise) {
    window.Promise = Promise
}

Vue.use(VueLocalStorage,{
  // namespace: 'vuejs__', // key prefix
  name: 'ls', // name variable Vue.[ls] or this.[$ls],
  storage: 'local', // storage name session, local, memory
})
Vue.prototype.$axios = axios
Vue.prototype.ls = VueLocalStorage

/**
 * Number format filter
 */
Vue.filter('number', function (value) {
    return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
})

window.Vaexvue = {}

window.getQueryString = function (field, url) {
    var href = url ? url : window.location.href
    var reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i')
    var string = reg.exec(href)
    return string ? string[1] : null
}

Vaexvue.Main = (function () {
    var init = function () {
    };

    /**
     * Map homepage
     * @type {Vue}
     */
    const map = function (site_id) {
        new Vue({
            el: '#map_load',
            data: {
              site_id
            },
            render: (h) => h(pointerlist)
        })
    }

    /**
     * Stock overview
     * @type {Vue}
     */
    const stockoverview = function (subdirectory, facebook, stockblock, translations, category) {
        new Vue({
            el: '#stockoverview',
            data: {
                subdirectory,
                facebook,
                stockblock,
                translations,
                category
            },
            render: (h) => h(list)
        })
    }

    /**
     * Stock favorites
     */
    const favorites = function (fulldomain) {
        new Vue({
            el: '#favorites',
            data: {fulldomain},
            render: (h) => h(favoritesList)
        })
    }

    /**
     * Gallery
     * @type {Vue}
     */
    const gallery = function (images) {
        new Vue({
            el: '#gallery',
            data: {
                images
            },
            render: (h) => h(imagegallery)
        })
    }

    /**
     * Gallery
     * @type {Vue}
     */
    var recent = function (current_id, translations) {
        new Vue({
            el: '#recentcontainer',
            data: {
                current_id,
                translations
            },
            render: (h) => h(recentViewed)
        })
    }

    /**
     * Textslider
     * @type {Vue}
     */
    var textslider = function () {
        new Vue({
            el: '#slider',
            render: (h) => h(slider)
        })
    }

    /**
     * Textslider
     * @type {Vue}
     */
    var photoreport = function (list, hide_categories, category, translations) {
        new Vue({
            el: '#photoreports',
            data: {
                list,
                hide_categories,
                category,
                translations
            },
            render: (h) => h(photoreportList)
        })
    }

    /**
     * Return methods
     */
    return {
        init,
        favorites,
        map,
        stockoverview,
        gallery,
        recent,
        textslider,
        photoreport
    }
})()



